module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, _vm._l((_vm.dataList), function(item, index) {
    return (!_vm.loading) ? _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-items": "center",
        "justify-content": "center",
        "align-items": "center"
      }
    }, [_c('div', {
      staticClass: "item-title",
      staticStyle: {
        "flex": "1"
      }
    }, [_c('div', [_vm._v("产品名称: " + _vm._s(item.productName.indexOf("A") > -1 ? "学驾易(驾考服务)A" : item.productName.indexOf("C") > -1 ? "学驾易(驾考服务)C" : item.productName))]), _vm._v(" "), _c('div', [_vm._v("产品价格(元): " + _vm._s(item.productFee))]), _vm._v(" "), _c('div', [_vm._v("产品介绍: "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(("意外伤残死亡赔偿限额： " + (item.productDisabilityFee + "" || "--") + "（元)\n每人补考费用限额：" + (item.productMakeupFee + "" || "--") + "（元）\n每人意外医疗限额： " + (item.productMedicalFee + "" || "--") + "（元）\n保障期间： " + (item.productInsuranceYear + "" || "--") + " 年\n保单生效以后不能退保")))])]), _vm._v(" "), _c('div', [_vm._v("产品状态:\n          "), (item.productState == 1) ? _c('van-tag', {
      attrs: {
        "type": "success",
        "size": "large"
      }
    }, [_vm._v("正常")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center",
        "width": "80px"
      }
    }, [_c('van-button', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.toubaoViewOpen(item)
        }
      }
    }, [_vm._v("投保")])], 1)])]) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-430401ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/driverSchool/toubaoManager.vue
// module id = 478
// module chunks = 1